import * as React from "react";
import type { SVGProps } from "react";
const SvgPencilIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="pencil_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M580.565 149.59c83.286-83.329 212.736-86.785 296.064-3.5 83.286 83.329 83.371 216.577 0 301.74L448 874.666a42.667 42.667 0 0 1-22.485 11.776l-289.835 57.6a42.667 42.667 0 0 1-49.664-49.664l54.101-293.675a42.667 42.667 0 0 1 11.819-22.485l428.63-428.63zM816.3 206.463c-50.006-50.005-125.44-46.507-175.403 3.456l-16.64 16.64 176.47 176.427 15.573-15.531a128 128 0 0 0 0-180.992zM275.627 575.147 451.328 750.89l288.896-287.702L563.925 286.89 275.627 575.146zm-55.894 64.768-38.57 209.066 205.653-41.984-167.083-167.082z"
    />
  </svg>
);
export default SvgPencilIcon;
